import { useProgressForwardShipment } from '../../hooks';
import { ShipmentProgress } from '../../models';
import { Item, ItemProps } from '../Item';

type ItemForwardProps = Omit<ItemProps, keyof ShipmentProgress>;

const ItemForward: React.FC<ItemForwardProps> = ({ ...props }) => {
  const progressProps = useProgressForwardShipment(props.baseShipment);

  return <Item {...props} {...progressProps} />;
};

export default ItemForward;
